import React, { useEffect, useRef, useState } from "react";
import "../Style/career.css";



import WhyJoinUs from "../components/whyjoinus";
import CareerOpportunity from "../components/careeroppurtunity";
import JoinNetwork from "../components/join";
import ClientFeedback from "../components/Clientfeedback";
import PageFooter from "../components/Footer";

function CareerPage() {
  const overlayRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (overlayRef.current) observer.observe(overlayRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section className="career-page">
        {/* CSS-only pattern layers, no images */}
        <div className="career-grid-pattern" aria-hidden="true" />
        <div className="career-blob career-blob-1" aria-hidden="true" />
        <div className="career-blob career-blob-2" aria-hidden="true" />
        <div className="career-blob career-blob-3" aria-hidden="true" />

        <div
          className={`career-overlay ${isVisible ? "career-visible" : ""}`}
          ref={overlayRef}
        >
          <div className="career-glass">
            {/* <img
              src={mpeoplesLogo}
              alt="MPeoples Logo"
              className="career-logo career-anim career-anim-1"
            /> */}

            <span className="career-eyebrow career-anim career-anim-2">
              Careers at MPeoples
            </span>

            <h1 className="career-title career-anim career-anim-3">
              Build Your Future With Us
            </h1>

            <p className="career-description career-anim career-anim-4">
              At MPeoples, we are committed to shaping careers by fostering
              continuous growth, innovation, and professional excellence and
              presence.
            </p>

            <button className="career-btn career-anim career-anim-5">
              Let&rsquo;s Build Together <span>↗</span>
            </button>
          </div>
        </div>
      </section>

      <WhyJoinUs />
      <CareerOpportunity />
      <JoinNetwork />
      <ClientFeedback />
      <PageFooter />
    </>
  );
}

export default CareerPage;